import { AxiosResponse } from 'axios'
import { http } from '../realisations/Http.realisation'
import {
    PretensionsAttachDocumentResponseT,
    PretensionsDownloadPretensionResponseT,
    PretensionsDownloadDocumentResponseT,
    PretensionsGetPretensionResponseT,
    PretensionsGetListResponseT,
    PretensionsGetParamsT,
    PretensionsGetStatusesResponseT,
    PretensionsGetTypesResponseT,
    PretensionsShowPretensionResponseT,
    PretensionsShowDocumentResponseT,
    CompensationsGetParamsT,
    PretensionChangeStatusT,
    PretensionShortT,
    QualityControlCommentT,
    PretensionsDownloadPretensionPayloadT,
    SBCommentT,
    GetGuiltySidesResponse,
} from '../types/pretensions.types'

export class PretensionsRepository {
    deletePretension(pretension_id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/cabinet/api/pretensions/${pretension_id}`)
    }

    deleteFile(id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/cabinet/api/file/${id}`)
    }

    getList(params: PretensionsGetParamsT): Promise<AxiosResponse<PretensionsGetListResponseT>> {
        return http.get('/cabinet/api/pretensions', { params })
    }

    exportExcel(
        payload: PretensionsDownloadPretensionPayloadT
    ): Promise<AxiosResponse<PretensionsDownloadPretensionResponseT>> {
        return http.get('/cabinet/api/pretensions/export', {
            responseType: 'blob',
            params: { ...payload },
        })
    }

    getPretension(
        pretension_id: number
    ): Promise<AxiosResponse<PretensionsGetPretensionResponseT>> {
        return http.get(`/cabinet/api/pretensions/${pretension_id}`)
    }

    createPretension(form_data: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData('/cabinet/api/pretensions', form_data)
    }

    saveAgreedData(params: CompensationsGetParamsT): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/pretensions/save-agreed-data/${params.id}`, params)
    }

    changeStatus(status_params: PretensionChangeStatusT): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/pretensions/change-status/${status_params.id}`, status_params)
    }

    saveLegalDepartmentComment(id: number, payload: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData(
            `/cabinet/api/pretensions/${id}/save-legal-department-comment`,
            payload
        )
    }

    updatePretensionInfo(params: PretensionShortT): Promise<AxiosResponse<void>> {
        return http.put(`/cabinet/api/pretensions/${params.id}`, params)
    }

    addQualityControlComment(comment_params: QualityControlCommentT): Promise<AxiosResponse<void>> {
        return http.put(
            `/cabinet/api/pretensions/save-quality-control-comment/${comment_params.id}`,
            { ...comment_params, status_id: 8 }
        )
    }

    addSBComment(comment_params: SBCommentT): Promise<AxiosResponse<void>> {
        return http.put(
            `/cabinet/api/pretensions/save-security-service-comment/${comment_params.id}`,
            comment_params
        )
    }

    addEmployeeFiles(files_params: FormData): Promise<AxiosResponse<void>> {
        return http.post(`/cabinet/api/pretensions/save-files`, files_params)
    }

    attachDocument(params: FormData): Promise<AxiosResponse<PretensionsAttachDocumentResponseT>> {
        return http.post(`/cabinet/api/pretensions/save-signed-pretension`, params)
    }

    downloadPretension(
        pretension_id: number
    ): Promise<AxiosResponse<PretensionsDownloadPretensionResponseT>> {
        return http.get(`/contract/api/contract/${pretension_id}/download`, {
            responseType: 'blob',
        })
    }

    showPretension(
        pretension_id: number
    ): Promise<AxiosResponse<PretensionsShowPretensionResponseT>> {
        return http.get(`/contract/api/contract/${pretension_id}/view`, { responseType: 'blob' })
    }

    downloadDocument(
        document_id: number
    ): Promise<AxiosResponse<PretensionsDownloadDocumentResponseT>> {
        return http.get(`/contract/api/contract/additional-document/${document_id}/download`, {
            responseType: 'blob',
        })
    }

    showDocument(document_id: number): Promise<AxiosResponse<PretensionsShowDocumentResponseT>> {
        return http.get(`/contract/api/contract/additional-document/${document_id}/view`, {
            responseType: 'blob',
        })
    }

    getTypes(page: number): Promise<AxiosResponse<PretensionsGetTypesResponseT>> {
        const params = {
            page,
        }

        return http.get('/cabinet/api/pretension-types', { params })
    }

    getGuiltySides(): Promise<AxiosResponse<GetGuiltySidesResponse>> {
        return http.get('/cabinet/api/dictionaries/guilty-sides')
    }

    getCompensations(page: number): Promise<AxiosResponse<PretensionsGetTypesResponseT>> {
        const params = {
            page,
        }

        return http.get('/cabinet/api/pretension-compensations', { params })
    }

    getCulprits(page: number): Promise<AxiosResponse<PretensionsGetTypesResponseT>> {
        const params = {
            page,
        }

        return http.get('/cabinet/api/pretension-culprits', { params })
    }

    getStatuses(page: number): Promise<AxiosResponse<PretensionsGetStatusesResponseT>> {
        const params = { page }

        return http.get('/cabinet/api/pretension-statuses', { params })
    }
}
